import { LessonMediaFiles } from 'types/models/lesson.model'

export const getMediaTypeFormatByFileName = (fileName: string) => {
	if (fileName.toLocaleLowerCase().search(/mpeg4|mp4|mkv/) !== -1) {
		return LessonMediaFiles.VIDEO
	}
	return LessonMediaFiles.AUDIO
}
